export default {
  getAllEmailTemplate: [],
  getEmailConfig: [],
  resetEmail: "",
  emailType: "Default",
  smsType: "Default",
};
